const Group = <template>
  <a href="{{@ctx.baseuri}}/tag_groups/{{@ctx.id}}">{{@ctx.tag_group.name}}</a>
</template>;

export default Group;
